export default __webpack_public_path__ + "static/media/power-on.e9c3ea37.png";